import {createApp} from 'vue'
import GlobalSearch from './GlobalSearch.vue'

document.addEventListener('DOMContentLoaded', () => {
    const searchContainer = document.getElementById('global-search')

    if(searchContainer) {
        const app = createApp({})

        app.component('global-search', GlobalSearch)

        app.directive('click-outside', {
            beforeMount(el, binding) {
                el.clickOutsideEvent = (event) => {
                    if(!(el === event.target || el.contains(event.target))) {
                        binding.value()
                    }
                }
                document.addEventListener('click', el.clickOutsideEvent)
            },
            unmounted(el) {
                document.removeEventListener('click', el.clickOutsideEvent)
            }
        })

        app.mount('#global-search')
    }
})